// Every design (including the original) gets an equal share of the card mix.
// Shuffle a small deck at a time, without rendering thousands of image nodes.
// Designs are purely cosmetic and never depend on the reserved prize/outcome.
export const buildCardDesigns = (count, photos = [], random = Math.random) => {
  const designs = [null, ...photos.filter((photo) => photo?.url)];
  const result = [];
  while (result.length < count) {
    const deck = [...designs];
    for (let i = deck.length - 1; i > 0; i--) {
      const j = Math.floor(random() * (i + 1));
      [deck[i], deck[j]] = [deck[j], deck[i]];
    }
    result.push(...deck.slice(0, count - result.length));
  }
  return result;
};
